const breakpoints = {
    desktop: 1025,
    'mobile-landscape': 480,
    'mobile-large-landscape': 568,
    'mobile-portrait': 320,
    'phablet-landscape': 736,
    'phablet-portrait': 414,
    'tablet-landscape': 1024,
    'tablet-portrait': 768,
};

/**
 * Expose the queries used here so they can be used elsewhere.
 * @type {Object}
 */
const queries = {
    xs: `(max-width: ${breakpoints['mobile-portrait'] - 1}px)`,
    sm:
        `(min-width: ${breakpoints['mobile-portrait']}px) and ` +
        `(max-width: ${breakpoints['mobile-large-landscape'] - 1}px)`,
    md:
        `(min-width: ${breakpoints['mobile-large-landscape']}px) and ` +
        `(max-width: ${breakpoints['tablet-portrait'] - 1}px)`,
    lg:
        `(min-width: ${breakpoints['tablet-portrait']}px) and ` +
        `(max-width: ${breakpoints.desktop - 1}px)`,
    xl: `(min-width: ${breakpoints.desktop}px)`,
};

export default queries;
